import { useEffect, useState } from 'react'

import { cn } from '@/utils/style'

interface RadioProps {
  disabled?: boolean
  checked?: boolean
  className?: string
  children?: React.ReactNode
  onChange?: (checked: boolean) => void
  checkedBgColor?: string
  checkedBorderColor?: string
  checkIconColor?: string
}

export function Checkbox({
  disabled,
  checked,
  className,
  children,
  onChange,
  checkedBgColor,
  checkedBorderColor,
  checkIconColor,
}: RadioProps) {
  const [selected, setSelected] = useState(checked ?? false)

  useEffect(() => {
    setSelected(checked ?? false)
  }, [checked])

  const inputBaseClass = [
    'appearance-none',
    'w-[18px] h-[18px]',
    'border-2',
    'bg-white',
    'relative',
    'transition',
    // 勾勾 (pseudo element) 預設隱藏
    'after:content-[""]',
    'after:absolute after:left-[28%] after:top-[6%]',
    'after:w-[45%] after:h-[75%]',
    'after:border-r-2 after:border-b-2 after:border-transparent',
    'after:scale-0 after:rotate-45 after:origin-left-top',
    'after:transition',
  ].join(' ')

  // 當 checkbox 被勾選且未 disabled 時，要額外套用的樣式
  const selectedClass =
    selected && !disabled
      ? cn(
          'after:scale-100', // 顯示勾勾
          checkIconColor ?? 'after:border-blue-500', // 預設勾勾顏色 blue‑500，可覆寫
          checkedBgColor ?? 'bg-blue-50', // 勾選後底色
          checkedBorderColor ?? 'border-blue-50', // 勾選後邊框，可覆寫
        )
      : ''

  return (
    <label className={cn('flex items-center gap-2', className)}>
      <input
        type="checkbox"
        className={cn(
          inputBaseClass,
          disabled && 'bg-panel-gray-200 cursor-not-allowed ',
          selectedClass,
        )}
        disabled={disabled}
        checked={selected}
        onChange={(e) => {
          setSelected(e.target.checked)
          onChange && onChange(e.target.checked)
        }}
      />
      {children}
    </label>
  )
}
